// extracted by mini-css-extract-plugin
export default {"background":"AgregarFicha_background__o-Luy","modal":"AgregarFicha_modal__16NHF","hr":"AgregarFicha_hr__JWgPE","form":"AgregarFicha_form__3Ofi4"};